/* Vivecalma: animaciones de entrada (un solo observador para toda la página). */
(function () {
  function initReveals() {
    var els = document.querySelectorAll('.vc-reveal:not(.vc-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('vc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vc-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', initReveals);
  document.addEventListener('shopify:section:load', initReveals);
})();

/* Barra fija de compra: aparece cuando la apertura sale de la pantalla. */
(function () {
  function initBarra() {
    var barra = document.querySelector('[data-vc-barra]');
    var hero = document.querySelector('.vc-hero');
    if (!barra || !hero || barra.dataset.vcListo) return;
    barra.dataset.vcListo = '1';
    barra.hidden = false;
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      barra.classList.toggle('vc-barra--visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(hero);
  }
  document.addEventListener('DOMContentLoaded', initBarra);
  document.addEventListener('shopify:section:load', initBarra);
})();

/* Comprar: une "cuántos" + "modelo" en la variante del producto ("Pack 2 · Mujer"). */
(function () {
  function initCompra(form) {
    if (form.dataset.vcListo) return;
    form.dataset.vcListo = '1';
    var datos = form.querySelector('[data-vc-variantes]');
    if (!datos) return;
    var variantes = JSON.parse(datos.textContent);
    var modelos = form.querySelector('[data-vc-modelos]');
    var idInput = form.querySelector('[data-vc-id]');
    var precio = form.querySelector('[data-vc-precio]');
    var boton = form.querySelector('[data-vc-boton]');
    function actualizar() {
      var grupo = (form.querySelector('input[name="vc-grupo"]:checked') || {}).value;
      var modelo = (form.querySelector('input[name="vc-modelo"]:checked') || {}).value;
      var delGrupo = variantes.filter(function (v) { return v.t.split(' · ')[0] === grupo; });
      if (modelos) modelos.hidden = delGrupo.length < 2;
      var v = delGrupo.length < 2 ? delGrupo[0] : delGrupo.filter(function (x) { return x.t.split(' · ')[1] === modelo; })[0] || delGrupo[0];
      if (!v) return;
      idInput.value = v.id;
      if (precio) precio.textContent = v.p;
      if (boton) boton.disabled = !v.ok;
    }
    form.addEventListener('change', actualizar);
    actualizar();
  }
  function init() { document.querySelectorAll('[data-vc-compra]').forEach(initCompra); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Galería: flechas que desplazan una foto. */
(function () {
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-vc-dir]');
    if (!btn) return;
    var pista = btn.closest('[data-vc-galeria]').querySelector('.vc-galeria__pista');
    var item = pista.querySelector('.vc-galeria__item');
    var paso = item ? item.getBoundingClientRect().width + 16 : pista.clientWidth * 0.8;
    pista.scrollBy({ left: paso * Number(btn.dataset.vcDir), behavior: 'smooth' });
  });
})();